var App = App || {};

App.SiteTour = (function ($) {
    "use strict";

    function init() {
        SiteTourTriggers();
        SiteTourModal();
        SiteTourCarousel();
        $(document).ready(function () {
            $("*[data-site-tour='open']").on("click", function () {
                SiteTourTriggers()
            });
        });
    }

    ////////////////////////////////////////////////////////////////////////////
    // MODAL TRIGGERS
    ////////////////////////////////////////////////////////////////////////////
    function SiteTourTriggers() {
        $("#SiteTourModal").modal("show");
        $("#SiteTourModal").find("*[data-bs-dismiss='modal']").on("click", function () {
            App.Cookies.setItem("SCFederal_SiteTour", "closed", Infinity, "/", window.location.hostname, window.location.protocol === "https:");
        });
    }

    ////////////////////////////////////////////////////////////////////////////
    // SITE TOUR MODAL
    ////////////////////////////////////////////////////////////////////////////
    function SiteTourModal() {

        $("#SiteTourModal").find("button[data-bs-advance='modal']").on("click", function () {
            $("#SiteTourModal .site-tour-items").slick("slickGoTo", 1, false);
        });
    }

    ////////////////////////////////////////////////////////////////////////////
    // SITE TOUR CAROUSEL
    ////////////////////////////////////////////////////////////////////////////
    function SiteTourCarousel() {

        var Carousel = $(".site-tour .site-tour-items");

        Carousel.on("init", function (event, slick) {
            SiteTourChange(Carousel, slick, 0);
        });

        Carousel.on("afterChange", function (event, slick, currentSlide, nextSlide) {
            SiteTourChange(Carousel, slick, currentSlide);
        });

        $("#SiteTourModal").on('shown.bs.modal', function (e) {
            if (ZAGFramework.GetCurrentBP() == "xxl" || ZAGFramework.GetCurrentBP() == "xl" || ZAGFramework.GetCurrentBP() == "lg") {
                SiteTourCarouselDestroy(Carousel);
                SiteTourCarouselSetup(Carousel);
            }
            $(document).bind("enter-xxl enter-xl enter-lg", function () {
                SiteTourCarouselDestroy(Carousel);
                SiteTourCarouselSetup(Carousel);
            });
            $(document).bind("enter-md enter-sm enter-xs", function () {
                SiteTourCarouselDestroy(Carousel);
            });

            $("#SiteTourModal").find("button[data-bs-reset='carousel']").on("click", function () {
                Carousel.slick("slickGoTo", 0, false);
            });
        });
    }

    ////////////////////////////////////////////////////////////////////////////
    // SITE TOUR CAROUSEL SETUP
    ////////////////////////////////////////////////////////////////////////////
    function SiteTourCarouselSetup(Carousel) {
        Carousel.slick({
            dots: false,
            arrows: true,
            appendArrows: $(".site-tour-carousel-controls"),
            prevArrow: '<button type="button" class="slick-prev"><span class="visually-hidden">Previous</span></button>',
            nextArrow: '<button type="button" class="slick-next"><span class="visually-hidden">Next</span></button>',
            autoplay: false,
            adaptiveHeight: false,
            infinite: false,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1
        });
    }

    ////////////////////////////////////////////////////////////////////////////
    // SITE TOUR CAROUSEL DESTROY
    ////////////////////////////////////////////////////////////////////////////
    function SiteTourCarouselDestroy(Carousel) {
        if (Carousel.hasClass("slick-initialized") == true) {
            Carousel.slick("unslick");
        }
    }

    ////////////////////////////////////////////////////////////////////////////
    // SITE TOUR CAROUSEL COUNTER
    ////////////////////////////////////////////////////////////////////////////
    function SiteTourChange(carousel, slick, current) {

        var TargetCurrent = carousel.siblings(".site-tour-carousel-controls").find(".site-tour-carousel-status-current");
        var TargetCount = carousel.siblings(".site-tour-carousel-controls").find(".site-tour-carousel-status-count");

        TargetCurrent.text(current + 1);
        TargetCount.text(slick.$slides.length);

        var text = $(slick.$slides[current]).find('.text').text();
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.SiteTour.init();
});